export const RouterSymbol = Symbol('@@router');
